// ** Type import
import { VerticalNavItemsType } from 'src/@core/layouts/types'
import { userStorage } from 'src/utils/localStorage'

const navigationAdmin = (): VerticalNavItemsType => {
    if (userStorage.isAdmin()) {
        return [
            {
                title: 'Administración',
                path: '/admin',
                icon: 'mdi:account-group-outline'
            },
            {
                title: 'Visualizador',
                path: '/grafo',
                icon: 'mdi:eye-outline'
            }
        ]
    } else {
        return []
    }
}

const navigation = (): VerticalNavItemsType => [
    {
        title: 'Home',
        path: '/home',
        icon: 'mdi:home-outline'
    },

    //   {
    //     title: 'Workflow',
    //     path: '/workflows',
    //     icon: 'mdi:email-outline'
    //   },

    // {
    //     title: 'Reportes',
    //     path: '/reports',
    //     icon: 'mdi:chart-bar'
    // },
    {
        title: 'Notificaciones',
        path: '/notifications',
        icon: 'mdi:bell-outline'
    },
    ...navigationAdmin()

    //   {
    //     title: 'Seguridad',
    //     path: '/security',
    //     icon: 'mdi:shield-outline'
    //   },
]

export default navigation
